import cl from 'classnames';
import * as React from 'react';
import { useSlate } from 'slate-react';
import styled from 'styled-components';

import { getNodes } from '../../../../../slatePlugins/common/queries/getNodes';
import { someNode } from '../../../../../slatePlugins/common/queries/someNode';
import { setDefaults } from '../../../../../slatePlugins/common/utils/setDefaults';
import { ToolbarButtonProps } from '../../../../../slatePlugins/components/ToolbarButton/ToolbarButton.types';
import { colorsV2 } from '../../../../colors-v2';
import { withDisableToolbarItem } from '../../../toolbars/disable-item/withDisableToolbarItem';
import DropdownToolbar from '../../../toolbars/DropdownToolbar';
import { DefaultBalloonToolbar } from '../../../toolbars/ToolbarWrapper';
import { DEFAULT_HIGHLIGHT } from '../defaults';
import { unwrapHighlight, upsertHighlightAtSelection } from '../transform/upsertAtSelection';
import { HighlightElementPluginOptions, HighlightOptions } from '../types';
import ColorSelector from './ColorSelector';

const ColorMenu = ({ colors, options, setVisibleMenu }) => {
  const editor = useSlate();
  const [match] = getNodes(editor, {
    match: { type: options.highlightElement.type } as any,
  }) as any;
  let currentColor = null;
  if (match) {
    currentColor = match[0].highlightKey;
  }

  return (
    <ColorSelector
      colors={colors}
      currentColor={currentColor}
      showDeselectColor
      onDeselectColor={() => {
        unwrapHighlight(editor, { ...options });
        setVisibleMenu(false);
      }}
      onSelectColor={(color) => {
        upsertHighlightAtSelection(editor, color.key, { ...options });
        setVisibleMenu(false);
      }}
    />
  );
};

const HighlightButton = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  user-select: none;
  cursor: pointer;
  vertical-align: middle;

  svg {
    display: block;
    width: 20px;
    height: 20px;
  }
  &.active {
    background-color: ${colorsV2.primary10};
    border-radius: 6px;
    svg {
      color: ${colorsV2.primary100};
    }
  }
`;

const ToolbarHighlightElementBase = ({
  highlightElement,
  colors,
  className,
  icon,
}: ToolbarButtonProps & HighlightOptions & HighlightElementPluginOptions) => {
  const options = setDefaults({ highlightElement }, DEFAULT_HIGHLIGHT);
  const editor = useSlate();
  const isActive = someNode(editor, { match: { type: options.highlightElement.type } as any });
  const [isVisible, setVisible] = React.useState(false);

  return (
    <DropdownToolbar
      visible={isVisible}
      overlay={
        <DefaultBalloonToolbar hidden={false} icon={icon}>
          <ColorMenu colors={colors} options={options} setVisibleMenu={setVisible} />
        </DefaultBalloonToolbar>
      }
      placement="topRight"
      onVisibleChange={setVisible}
    >
      <HighlightButton
        className={cl(className, { 'slate-ToolbarButton-active': isActive, active: isActive })}
      >
        {icon}
      </HighlightButton>
    </DropdownToolbar>
  );
};

export const ToolbarHighlightElement = withDisableToolbarItem(ToolbarHighlightElementBase);
